import React, { Component, Fragment } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd';
import Table from '@/components/EditableTable';

const selectInterfaceColumns = [
  {
    dataIndex: "check",
    key: "check",
    width: 80
  },
  {
    title: 'Type',
    dataIndex: 'type',
    width: 90
  }, {
    title: 'Signal Name',
    dataIndex: 'name',
    width: '28%'
  },
  {
    title: 'Signal Type',
    dataIndex: 'signalType',
    width: 100
  },
  {
    title: 'Nets',
    dataIndex: 'nets',
    /* width: '54%' */
  }
]

class SelectContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: []
    }

    const defaultColumns = JSON.parse(JSON.stringify(selectInterfaceColumns));
    this.selectInterfaceColumns = defaultColumns.map(item => {
      switch (item.dataIndex) {
        case 'check':
          item.title = () => {
            const { checked, indeterminate, selectedProportion } = this.getCheckBoxStatus()
            return <Fragment>
              <Checkbox
                indeterminate={indeterminate}
                checked={checked}
                onChange={(e) => this.props.checkSignals(e, 'all')}
              />
              <span className="select-checkbox-title-proportion">{selectedProportion}</span>
            </Fragment>
          }
          item.render = (check, record) => {
            const { checked } = this.getCheckBoxStatus(record.interfaceKey)
            return <div className='pcb-channel-table-checkBox'>
              <Checkbox
                checked={checked}
                onChange={(e) => this.props.checkSignals(e, record.interfaceKey)}
              />
            </div>
          }
          item.onCell = (record) => {
            return {
              edit: false,
              rowSpan: record.contentLength
            }
          }
          break;
        case 'type':
          item.render = (type, record) => {
            const { selectedDesignIDs, pcbId } = this.props;
            const pcbOpened = selectedDesignIDs.includes(pcbId);
            return <span
              className={pcbOpened ? 'cursor-pointer' : ""}
              onClick={pcbOpened ? (e) => this.props.showNetsToLayout({ e, pcbId: record.pcbId, interfaceKey: record.interfaceKey }) : null}
            >{type}</span>;
          }
          item.onCell = (record) => {
            return {
              edit: false,
              rowSpan: record.contentLength
            }
          }
          break;
        case 'name':
          item.render = (_, record) => {
            return <span
              title={record.signalMergeName || record.name}
            >{record.signalMergeName || record.name}</span>
          }
          item.onCell = (record) => {
            return {
              record,
              edit: true,
              dataIndex: 'signalMergeName',
              handleSave: (row) => this.props.updateSignalName(row)
            }
          }
          break;
        case 'nets':
          item.render = (nets, record) => {
            if (nets.length) {
              const { selectedDesignIDs, pcbId } = this.props;
              const pcbOpened = selectedDesignIDs.includes(pcbId);
              return <div
                className={pcbOpened ? 'cursor-pointer' : ""}
                onClick={pcbOpened ? (e) => this.props.showNetsToLayout({ e, pcbId: record.pcbId, signalNets: record.nets }) : null}
              >{nets.join(', ')}</div>
            }
            else { return null }
          }
          item.title = () => {
            const { selectedDesignIDs, pcbId } = this.props;
            const pcbOpened = selectedDesignIDs.includes(pcbId);
            return (
              <div>
                <span>Nets</span>
                <EyeOutlined
                  title={pcbOpened ? "View Nets To Layout" : "Please Open PCB Layout"}
                  className={pcbOpened ? 'creation-interface-nets-eye-icon' : "creation-interface-nets-eye-disabled-icon"}
                  onClick={pcbOpened ? (e) => this.props.showNetsToLayout({ e, pcbId }) : null} />
              </div>
            );
          }
          break;
        default:
          break;
      }
      return item;
    })
  }

  componentDidMount = () => {
    const { allInterfaceCompNetData } = this.props;
    if (allInterfaceCompNetData && allInterfaceCompNetData.length) {
      this.getDataSource(allInterfaceCompNetData)
    }
  }

  componentDidUpdate = (prevProps) => {
    const { allInterfaceCompNetData, signalStatus } = this.props;
    if ((prevProps.allInterfaceCompNetData && allInterfaceCompNetData && allInterfaceCompNetData.length !== prevProps.allInterfaceCompNetData.length)
      || (signalStatus && signalStatus !== prevProps.signalStatus)) {
      this.getDataSource(allInterfaceCompNetData)
      this.props.updateSignalStatus(false)
    }
  }

  getCheckBoxStatus = (key) => {
    const { allInterfaceCompNetData, selectKeys } = this.props;

    let checked = false, indeterminate = false;
    if (key) {
      if (selectKeys.includes(key)) { checked = true }
      else { checked = false }
      return { checked }
    }
    const selectedProportion = `${selectKeys.length}/${allInterfaceCompNetData.length}`;
    if (selectKeys.length === 0) { return { checked, indeterminate, selectedProportion }; }
    if (allInterfaceCompNetData.length === selectKeys.length) {
      checked = true;
      indeterminate = false;
    } else {
      checked = false;
      indeterminate = true;
    }
    return { checked, indeterminate, selectedProportion };
  }

  getDataSource = (allInterfaceCompNetData) => {
    let dataSource = [];
    let key = 0;
    for (let info of allInterfaceCompNetData) {
      key = key + 1;
      const { content, type, pcbId, pcbs, interfaceKey } = info;

      content.forEach((item, index) => {
        const { name, nets, signalMergeName, signalId, signalType } = item;
        const defaultData = { interfaceKey, signalMergeName, name, nets, pcbId, pcbs, check: false, signalId, signalType }
        if (index < 1) {
          dataSource.push({ type, contentLength: content.length, signalDisplay: true, ...defaultData })
        } else {
          dataSource.push({ contentLength: 0, signalDisplay: false, ...defaultData })
        }
      })
    }

    this.setState({
      dataSource
    })
  }

  render = () => {
    const { dataSource } = this.state
    const { pcbId } = this.props;
    const _dataSource = dataSource.map((item, index) => { return { ...item, index } })
    return <Fragment>
      <div className="interface-identification-select-content">
        <Table
          columns={this.selectInterfaceColumns}
          dataSource={_dataSource}
          rowKey={(record) => `${pcbId}-${record.name}-${record.index}`}
          size="small"
          pagination={false}
          tableLayout="fixed"
          className="identification-select-table"
          scroll={
            dataSource && dataSource.length && dataSource.length > 8
              ? { y: 400 }
              : {}
          }
        />
      </div>
    </Fragment>
  }
}

export default SelectContent;